module.exports = __webpack_public_path__ + "img/pdf.59c5172d.svg";